/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Why_Openrift_DescriptionInputs */



/**
* | output |
* | --- |
* | "The story behind the app: why it exists, what it does differently, where it is still catching up, and what it runs on." |
*
* @param {Help_Article_Why_Openrift_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_why_openrift_description = /** @type {((inputs?: Help_Article_Why_Openrift_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Why_Openrift_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Geschichte hinter der App: warum es sie gibt, was sie anders macht, wo sie noch aufholt und worauf sie läuft.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'histoire de l'application : pourquoi elle existe, ce qu'elle fait différemment, ce qu'il lui reste à rattraper et sur quoi elle tourne.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("这个应用背后的故事：它为何存在、有哪些不一样的做法、哪些地方还在追赶，以及它跑在什么技术上。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("這個應用程式背後的故事：它為何存在、有什麼不一樣、哪些地方還在追趕，以及它建立在什麼技術上。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("이 앱의 이야기입니다. 왜 만들어졌는지, 무엇이 다른지, 아직 부족한 부분은 무엇인지, 어떤 기술로 돌아가는지 소개합니다.")
	return /** @type {LocalizedString} */ ("The story behind the app: why it exists, what it does differently, where it is still catching up, and what it runs on.")
});